import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useKeycloak } from '@react-keycloak/web';
import LoadingSpinner from './components/common/LoadingSpinner';
import { MapPage } from './pages/MapPage';
import { HomePage } from './pages/HomePage';
import { FarmStateProvider } from './config/FarmContext';
import { ErrorPage } from './pages/ErrorPage';
import TabComponent from './components/layout/TabComponent';
import { SubscriptionPage } from './pages/SubscriptionPage';
import Impressum from './pages/Impressum';
import Contact from "./pages/Contact";
import { NotFound } from "./pages/NotFound";
import { ProfilePage } from './pages/ProfilePage';
import './App.css';
import { Navigate } from "react-router-dom";
import { useEffect } from "react";

export const App = () => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    const clientKey = process.env.REACT_APP_CRONITOR_CLIENT_ID;

    if (clientKey) {
      const script = document.createElement('script');
      script.src = 'https://rum.cronitor.io/script.js';
      script.async = true;
      document.head.appendChild(script);

      (window as any).cronitor = (window as any).cronitor || function () {
        ((window as any).cronitor.q = (window as any).cronitor.q || []).push(arguments);
      };

      (window as any).cronitor('config', { clientKey });
    }
  }, []);

  if (!initialized) {
    return <LoadingSpinner />;
  }

  return (
    <FarmStateProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/error" element={<ErrorPage />} />

          <Route path="*" element={<NotFound />} />
          <>
            <Route
              path="/map"
              element={keycloak.authenticated ? <MapPage /> : <Navigate to="/" replace />}
            />
            <Route
              path="/betrieb"
              element={keycloak.authenticated ? <TabComponent /> : <Navigate to="/" replace />}
            />
            <Route
              path="/profile"
              element={keycloak.authenticated ? <ProfilePage /> : <Navigate to="/" replace />}
            />
          </>
        </Routes>
      </BrowserRouter>
    </FarmStateProvider>
  );
};